import React, { useEffect, useState } from 'react'
import { JobSearch } from '../../config/imagesLink';
import { useTranslation } from 'react-i18next';
import { BiChevronDown } from "react-icons/bi";
import WorkOutlineSharpIcon from "@mui/icons-material/WorkOutlineSharp";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

const FilterCheck = ({ id, checked, onChange, label }) => (
    <li>
        <label className="js-filter-check" htmlFor={id}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
            />
            <span>{label}</span>
        </label>
    </li>
);

const JobFilter = ({
    jobTypeList,
    setSelectedJobTypeData,
    salaryTypeList,
    setSelectedSalaryType,
    workLevelTypeList,
    setSelectedWorkLevel,
    workLocationType,
    setSelectedWorkLocationList,
    setReset
}) => {
    //************************ jobs type filter  ************************//
    const [selectedsinglejobtype, setselectedsinglejobtype] = useState([]);
    const { t } = useTranslation();
    const handlejobType = (item) => {
        if (selectedsinglejobtype.includes(item.id)) {
            setReset(true)
            setselectedsinglejobtype(selectedsinglejobtype.filter((id) => id !== item.id));
            // AllJobList();
        } else {
            setReset(true)
            setselectedsinglejobtype([...selectedsinglejobtype, item.id]);
            // AllJobList();
        }
    };
    useEffect(() => {
        setSelectedJobTypeData(selectedsinglejobtype);
    }, [selectedsinglejobtype]);
    //************************ jobs type filter  ************************//


    //************************ salary type filter  ************************//
    const [selectedSalaryTypeList, setSelectedSalaryTypeList] = useState([]);
    const handleSalaryType = (item) => {
        if (selectedSalaryTypeList.includes(item.id)) {
            setReset(true)
            setSelectedSalaryTypeList(selectedSalaryTypeList.filter((id) => id !== item.id));
            // AllJobList();
        } else {
            setReset(true)
            setSelectedSalaryTypeList([...selectedSalaryTypeList, item.id]);
            // AllJobList();
        }

    };
    useEffect(() => {
        setSelectedSalaryType(selectedSalaryTypeList);
    }, [selectedSalaryTypeList]);
    //************************ salary type filter  ************************//


    //************************ work level type filter  ************************//
    const [selectedWorkLevelList, setSelectedWorkLevelList] = useState([]);
    const handleWorkLevelTypeList = (item) => {
        if (selectedWorkLevelList.includes(item.id)) {
            setReset(true)
            setSelectedWorkLevelList(selectedWorkLevelList.filter((id) => id !== item.id));
            // AllJobList();
        } else {
            setReset(true)
            setSelectedWorkLevelList([...selectedWorkLevelList, item.id]);
            // AllJobList();
        }
    };
    useEffect(() => {
        setSelectedWorkLevel(selectedWorkLevelList);
    }, [selectedWorkLevelList]);

    //************************ work level type filter  ************************//


    //************************ work locaion type filter  ************************//
    const [selectedWorkLocation, setSelectedWorkLocation] = useState([]);
    const handleWorkLocation = (item) => {
        if (selectedWorkLocation.includes(item.id)) {
            setReset(true)
            setSelectedWorkLocation(selectedWorkLocation.filter((id) => id !== item.id));
            // AllJobList();
        } else {
            setReset(true)
            setSelectedWorkLocation([...selectedWorkLocation, item.id]);
            // AllJobList();
        }
    };
    useEffect(() => {
        // console.log("selectedWorkLocation", selectedWorkLocation);
        setSelectedWorkLocationList(selectedWorkLocation);
    }, [selectedWorkLocation]);



    //************************ work locaion type filter  ************************//

    const [openSections, setOpenSections] = useState({
        jobType: true,
        salary: false,
        workLevel: false,
        workLocation: false,
    });

    const toggleSection = (section) => {
        setOpenSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    return (
        <>
            {/* <div className="py-3 advertiseImage desktopView">
                <img src={JobSearch.ad1} alt="" />
            </div> */}

            <div className="mb-2 accordion Jobfilter" id="accordionExample">

                {jobTypeList !== null && (
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button
                                className={`accordion-button f-14${openSections.jobType ? '' : ' collapsed'}`}
                                type="button"
                                aria-expanded={openSections.jobType}
                                aria-controls="collapseOne"
                                onClick={() => toggleSection('jobType')}
                            >
                                <span className="js-filter-title">
                                    <WorkOutlineSharpIcon className="js-filter-icon" />
                                    {t("SearchJob.Job Type List")}
                                </span>
                                <BiChevronDown className="accordion-icon ms-auto" />
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className={`accordion-collapse collapse${openSections.jobType ? ' show' : ''}`}
                            aria-labelledby="headingOne"
                        >
                            <div className="accordion-body pt-0 pb-0">
                                <ul>
                                    {jobTypeList?.map((item) => (
                                        <FilterCheck
                                            key={item.id}
                                            id={`jobtype-${item.id}`}
                                            checked={selectedsinglejobtype.includes(item.id)}
                                            onChange={() => handlejobType(item)}
                                            label={item.name}
                                        />
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                        <button
                            className={`accordion-button f-14${openSections.salary ? '' : ' collapsed'}`}
                            type="button"
                            aria-expanded={openSections.salary}
                            aria-controls="collapseTwo"
                            onClick={() => toggleSection('salary')}
                        >
                            <span className="js-filter-title">
                                <PaymentsOutlinedIcon className="js-filter-icon" />
                                {t("SearchJob.Salary Type List")}
                            </span>
                            <BiChevronDown className="accordion-icon ms-auto" />
                        </button>
                    </h2>
                    <div
                        id="collapseTwo"
                        className={`accordion-collapse collapse${openSections.salary ? ' show' : ''}`}
                        aria-labelledby="headingTwo"
                    >
                        <div className="accordion-body pt-0 pb-0">
                            <ul>
                                {salaryTypeList?.map((item) => (
                                    <FilterCheck
                                        key={item.id}
                                        id={`salary-${item.id}`}
                                        checked={selectedSalaryTypeList.includes(item.id)}
                                        onChange={() => handleSalaryType(item)}
                                        label={item.name}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                        <button
                            className={`accordion-button f-14${openSections.workLevel ? '' : ' collapsed'}`}
                            type="button"
                            aria-expanded={openSections.workLevel}
                            aria-controls="collapseThree"
                            onClick={() => toggleSection('workLevel')}
                        >
                            <span className="js-filter-title">
                                <LayersOutlinedIcon className="js-filter-icon" />
                                {t("SearchJob.Work Level Type List")}
                            </span>
                            <BiChevronDown className="accordion-icon ms-auto" />
                        </button>
                    </h2>
                    <div
                        id="collapseThree"
                        className={`accordion-collapse collapse${openSections.workLevel ? ' show' : ''}`}
                        aria-labelledby="headingThree"
                    >
                        <div className="accordion-body pt-0 pb-0">
                            <ul>
                                {workLevelTypeList?.map((item) => (
                                    <FilterCheck
                                        key={item.id}
                                        id={`worklevel-${item.id}`}
                                        checked={selectedWorkLevelList.includes(item.id)}
                                        onChange={() => handleWorkLevelTypeList(item)}
                                        label={item.name}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                        <button
                            className={`accordion-button f-14${openSections.workLocation ? '' : ' collapsed'}`}
                            type="button"
                            aria-expanded={openSections.workLocation}
                            aria-controls="collapseFour"
                            onClick={() => toggleSection('workLocation')}
                        >
                            <span className="js-filter-title">
                                <PlaceOutlinedIcon className="js-filter-icon" />
                                {t("SearchJob.Work Location")}
                            </span>
                            <BiChevronDown className="accordion-icon ms-auto" />
                        </button>
                    </h2>
                    <div
                        id="collapseFour"
                        className={`accordion-collapse collapse${openSections.workLocation ? ' show' : ''}`}
                        aria-labelledby="headingFour"
                    >
                        <div className="accordion-body pt-0 pb-0">
                            <ul>
                                {workLocationType?.map((item) => (
                                    <FilterCheck
                                        key={item.id}
                                        id={`location-${item.id}`}
                                        checked={selectedWorkLocation.includes(item.id)}
                                        onChange={() => handleWorkLocation(item)}
                                        label={item.name}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

            </div>


        </>
    )
}

export default JobFilter